import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { ColumnMenu } from "../components/kendoComponents/columnMenu/ColumnMenu";
import { GridPager } from "../components/kendoComponents/gridPager/GridPager";
import { ColumnProps } from "../components/kendoComponents/columnProps/ColumnProps";
import { useNavigate } from "react-router-dom";
import LoaderSpin from "../components/loaderSpin/LoaderSpin";
import ModalManualValidation from "../components/manualValidation/ModalManualValidation";
import "../assets/scss/kendo-theme-custom.scss";
import {
  fetchVersionList,
  setCallWithUser,
} from "../store/app/DataRollCall/DataRollCallSlice";
import FilterOverlay from "../components/filterOverlay/FilterOverlay";
import DateCell from "../components/kendoComponents/dateCell/DateCell";
import { AtlanCell } from "../components/customRender/renders/Renders";
import RollCallFilterForm from "../components/DataQuality/RollCallFilterForm";
import useRollCallGrid from "../components/hooks/useRollCallGrid";
import PropTypes from "prop-types";

const VersionCell = ({ dataItem, navigate, searchParams }) => {
  const handleNavigate = () => {
    navigate(`/versioni/detail/${dataItem.versionId}?${searchParams.toString()}`);
  };

  return (
    <td>
      <button
        type="button"
        tabIndex={0}
        style={{ cursor: "pointer", background: "none", border: "none", padding: 0 }}
        className="fw-bold text-decoration-underline"
        onClick={handleNavigate}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") handleNavigate(); }}
        aria-label={`Go to Version ${dataItem.versionId}`}
      >
        {dataItem.versionId}
      </button>
    </td>
  );
};

VersionCell.propTypes = {
  dataItem: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const VersionListRollCall = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  const refreshCount = useSelector((state) => state.dataQualityReducer.refreshCount);
  const callWithUser = useSelector((state) => state.dataRollCallReducer.callWithUser);
  const isSpinnerVisible = useSelector((state) => state.dataQualityReducer.loading);
  const dataCheck = useSelector((state) => state.dataQualityReducer.dataCheck);
  const versionList = useSelector((state) => state.dataRollCallReducer.versionList || []);
  const filterDomains = useSelector((state) => state.dataQualityReducer.filterDomains);
  const filterStatusCount = useSelector((state) => state.dataRollCallReducer.filterStatusCountDomains);
  const filterProductTypes = useSelector((state) => state.dataRollCallReducer.filterProductTypes);
  const filterDataProducts = useSelector((state) => state.dataQualityReducer.filterDataProducts);

  const { dataState, dataResult, onDataStateChange } = useRollCallGrid(versionList);

  const [modal, setModal] = useState(false);
  const toggleManualValidation = () => setModal(!modal);

  useEffect(() => {
    dispatch(fetchVersionList(filterStatusCount, filterDomains, filterProductTypes, callWithUser, filterDataProducts));
    dispatch(setCallWithUser(false));
  }, [refreshCount, navigate]);

  const renderVersionCell = (props) => (
    <VersionCell {...props} navigate={navigate} searchParams={searchParams} />
  );

  return (
    <>
      <RollCallFilterForm />
      <Container fluid className="py-2 px-4 position-relative">
        <Row>
          <Col>
            <div className="grid_task_container border">
              <Grid
                style={{ height: "100%" }}
                pageable={true}
                sortable={true}
                groupable={true}
                total={dataResult?.length}
                data={dataResult}
                {...dataState}
                pager={(props) => GridPager(props, versionList)}
                onDataStateChange={onDataStateChange}
              >
                <Column {...ColumnProps("versionId", dataState)} title="Version ID" columnMenu={ColumnMenu} width={120} cell={renderVersionCell} />
                <Column {...ColumnProps("productName", dataState)} title="Product" columnMenu={ColumnMenu} cell={(props) => AtlanCell(props, "productName", "typeHandle")} />
                <Column {...ColumnProps("referenceDate", dataState)} title="Reference Date" columnMenu={ColumnMenu} cell={(props) => DateCell(props, false)} />
                <Column {...ColumnProps("creationTs", dataState)} title="Version Creation" columnMenu={ColumnMenu} cell={(props) => DateCell(props, true)} />
                <Column {...ColumnProps("extStatusName", dataState)} title="Status" columnMenu={ColumnMenu} />
                <Column {...ColumnProps("windowStartTs", dataState)} title="Window Start" columnMenu={ColumnMenu} cell={(props) => DateCell(props, true)} />
                <Column {...ColumnProps("windowEndTs", dataState)} title="Window End" columnMenu={ColumnMenu} cell={(props) => DateCell(props, true)} />
                <Column {...ColumnProps("rollCallStatusName", dataState)} title="Roll-Call Status" />
                <Column {...ColumnProps("rollCallSeverityName", dataState)} title="Severity" />
              </Grid>
            </div>
          </Col>
        </Row>
        <LoaderSpin isVisible={isSpinnerVisible} />
        <FilterOverlay isVisible={dataCheck} />
      </Container>
      <ModalManualValidation modal={modal} toggleManualValidation={toggleManualValidation} />
    </>
  );
};

export default VersionListRollCall;